import { render, staticRenderFns } from "./ProductCompositionTooltip2.vue?vue&type=template&id=373c806f&"
import script from "./ProductCompositionTooltip2.vue?vue&type=script&lang=js&"
export * from "./ProductCompositionTooltip2.vue?vue&type=script&lang=js&"
import style0 from "./ProductCompositionTooltip2.vue?vue&type=style&index=0&id=373c806f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports